export default __webpack_public_path__ + "static/process-5-93fb303441425d710163c2082ff6b342.jpeg";